import {get, deleteRequest, post, put } from './api'
import { getServerInfo } from '../utils/helpers/networkInfo.helper';

const serverUrl = getServerInfo('api');

export class UserService {
    static getAll(token, queryParams = {}) {
        return get(`${serverUrl}users`, token, queryParams)
    }

    static getById(id, token) {
        return get(`${serverUrl}users/${id}`, token)
    }

    static bulkDelete(ids, token) {
        return deleteRequest(`${serverUrl}users`, { ids }, true, token)
    }

    static delete(id, token) {
        return deleteRequest(`${serverUrl}users/${id}`, null, false, token)
    }

    static create(data, token) {
        return post(`${serverUrl}users`, data, true, token)
    }

    static update(id, data, token) {
        return put(`${serverUrl}users/${id}`, data, true, token)
    }

    //Obtener usuarios (profesores)) asociados a un curso
    static getcoursesxUserById(id, token) {
        return get(`${serverUrl}coursesxUser/${id}`, token)
    }

    //Obtener usuarios (estudiantes) asociados a un curso
    static getcoursesxUserEById(id, token) {
        return get(`${serverUrl}coursesxUserE/${id}`, token)
    }

    static getHour() {
        return get(`${serverUrl}hour`)
    }

}